import api from './api';
import type { Owner, PaginatedResponse } from '../types';

interface ListOwnersParams {
  page?: number;
  limit?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  search?: string;
}

interface CreateOwnerInput {
  userId: string;
  name: string;
  phone?: string;
  address?: string;
}

export interface LinkableOwnerUser {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
}

interface UpdateOwnerInput {
  name?: string;
  email?: string;
  phone?: string;
  address?: string;
  isActive?: boolean;
}

export async function listOwners(params: ListOwnersParams = {}): Promise<PaginatedResponse<Owner>> {
  const response = await api.get<PaginatedResponse<Owner>>('/owners', { params });
  return response.data;
}

export async function getOwner(id: string): Promise<Owner> {
  const response = await api.get<Owner>(`/owners/${id}`);
  return response.data;
}

export async function getLinkableOwnerUsers(): Promise<LinkableOwnerUser[]> {
  const response = await api.get<LinkableOwnerUser[]>('/owners/linkable-users');
  return response.data;
}

export async function createOwner(data: CreateOwnerInput): Promise<Owner> {
  const response = await api.post<Owner>('/owners', data);
  return response.data;
}

export async function updateOwner(id: string, data: UpdateOwnerInput): Promise<Owner> {
  const response = await api.put<Owner>(`/owners/${id}`, data);
  return response.data;
}

export async function deleteOwner(id: string): Promise<void> {
  await api.delete(`/owners/${id}`);
}
